export default __webpack_public_path__ + "static/media/0_lower_left.361a2fef.svg";